import React from "react"

import { FieldItems } from "@tenforce/toolbox-field-react"

import { GlobalState } from "../../../../store"
import { useAppSelector } from "../../../../hooks"

import { ICheckListViewActions, IChecklistViewFinding } from "../.."

import Finding from "./Finding"

export interface Props {
    containerElement: string
    contextMenuActions: ICheckListViewActions
    findings: IChecklistViewFinding[] | null
    isLabelShown: boolean
}

export const FindingList = ({
    containerElement,
    contextMenuActions,
    findings,
    isLabelShown,
}: Props): JSX.Element => {
    const { labels } = useAppSelector((state: GlobalState) => state.audits)

    return (
        <>
            {!!findings && findings.length > 0 && (
                <FieldItems
                    data-ft-component={containerElement}
                    data-ft-count={findings.length}
                    label={isLabelShown ? labels.Findings : ""}
                    labelProps={{ extraClasses: "is-dimmed" }}
                    itemsProps={{
                        extraClasses: "tw-flex-col",
                        hasNormalAlignment: true,
                    }}
                >
                    {findings.map((finding) => (
                        <Finding
                            key={finding.id}
                            contextMenuActions={contextMenuActions}
                            {...finding}
                        />
                    ))}
                </FieldItems>
            )}
        </>
    )
}

export default FindingList
